// TODO on successful create, redirect to the edit page for it
import React from 'react';
import PropTypes from 'prop-types';
import { Page } from '../../components';
import PlanForm from './PlanForm';

const propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      carrierId: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};
export default function NewPlan(props) {
  const { match: { params: { carrierId } } } = props;
  return (
    <Page
      breadcrumbs={[{ content: 'Plans', href: `/carriers/${carrierId}/plans` }]}
      title="Add Plan"
    >
      <PlanForm />
    </Page>
  );
}
NewPlan.propTypes = propTypes;
